import CloseIcon from '@mui/icons-material/Close';
import { MenuItem } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import router from 'next/router';
import type React from 'react';
import { brandColors } from '@/styles/theme/values/brandColors';
import type { HeaderContent } from '../../../../contentful';
import SunrunLogo from '../../../../public/cmsAssets/assets/img/logo/TextLogo';
import { trackEvents } from '../../../../utils/analytics';
import useStyles from './Navigation.styles';

interface Props {
  open: boolean;
  onClose: () => void;
  content?: HeaderContent;
}

/**
 * @deprecated V2 component
 */
export default function Navigation({
  open,
  onClose,
  content,
}: Props): React.JSX.Element {
  const { classes } = useStyles();

  return (
    <Drawer
      anchor={'top'}
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawer }}
      transitionDuration={400}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <div className='sidebarWrapper'>
        <div className='sidemenuWrapper'>
          <div className='headerElementsWrapper'>
            <SunrunLogo
              width='110'
              color={brandColors.primaryMain}
              classname={classes.logo}
            />
            {/** biome-ignore lint/a11y/useButtonType: Automated migration to Biome */}
            <button
              className={classes.closeIcon}
              onClick={onClose}
              aria-label='Close'
            >
              <CloseIcon />
            </button>
          </div>
          <div className='sidebarMenu'>
            {content?.fields?.categories.map((category) => (
              <div
                className={`${classes.menuItem} ${classes.item}`}
                key={category.sys.id}
              >
                <div>
                  {category.fields.name}
                  {category.fields.links.map((link) => (
                    <MenuItem
                      key={link.sys.id}
                      onClick={() => {
                        trackEvents({
                          event: 'Hamburger click',
                          click_text: link.fields.text,
                        });
                        setTimeout(onClose, 1500);
                        router.push(link.fields.url);
                      }}
                    >
                      {link.fields.text}
                    </MenuItem>
                  ))}
                </div>
              </div>
            ))}
            {/** biome-ignore lint/correctness/noRestrictedElements: Automated migration to Biome */}
            <a href='/free-solar-quote'>
              <p className='sidebarMenu-element'>Get a Quote</p>
            </a>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
